import {
  KengenMaster,
  kigyonaiShinchokuMaster,
  shinseiStatusMaster,
  ShoninCommentBunruiMaster,
  toiawaseJokyoMaster,
  UnyoMaster,
} from "@/interfaces/masterTable.interface";
import request from "@/utils/request";

export async function getAllKengen(): Promise<KengenMaster[]> {
  const {
    data: { result },
  } = await request({
    url: `account/getAllKengen`,
    method: "get",
  });
  return result;
}

export async function getUnyoList(): Promise<UnyoMaster[]> {
  const {
    data: { result },
  } = await request({
    url: `kaisha/getUnyoList`,
    method: "get",
  });
  return result;
}

export async function getShoninCommentBunruiList(): Promise<
  ShoninCommentBunruiMaster[]
> {
  const {
    data: { result },
  } = await request({
    url: `shoninCommentHojo/getBunruiList`,
    method: "get",
  });
  return result;
}

export async function getStatusList(): Promise<shinseiStatusMaster[]> {
  const {
    data: { result },
  } = await request({
    url: `shinseiKanri/getStatusList`,
    method: "get",
  });
  return result;
}

export async function getKigyonaiShinchokuList(): Promise<
  kigyonaiShinchokuMaster[]
> {
  const {
    data: { result },
  } = await request({
    url: `shinseiKanri/getKigyonaiShinchokuList`,
    method: "get",
  });
  return result;
}

export async function getToiawaseJokyoList(): Promise<toiawaseJokyoMaster[]> {
  const {
    data: { result },
  } = await request({
    url: `toiawase/getJokyoList`,
    method: "get",
  });
  return result;
}
